/* eslint-disable no-unused-vars */
import { useLocation } from 'react-router-dom'

import { REACT_APP_DOMAIN, REACT_APP_ENV } from '../common/constants'
import { checkEnvironment } from '../utils/helpers'

function NoMatch() {
  const { pathname } = useLocation()
  const errorPage = `${REACT_APP_DOMAIN}${
    checkEnvironment(REACT_APP_ENV, 'usedcars')
      ? '404'
      : `Error/PageNotFound?aspxerrorpath=${pathname}`
  }`

  // window.location.replace(errorPage)
  return null
}

export default NoMatch
